import { CommonModule } from '@angular/common';
import { ApplicationRef, Component, Input } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { NgSelectComponent, NgSelectModule } from '@ng-select/ng-select';
import { JobTypeEnum } from '../../../../../../../shared/Container/enum/JobTypeEnum';
import { AbstractContainerJobTypeHelper } from '../../../../../../../shared/Container/Helper/AbstractContainerJobTypeHelper';
import { Division } from '../../../../../../../shared/Jobbing/models/Division';
import { ContainerService } from '../../../../../../../shared/Container/container.service';
import { DepotManagementService } from '../../../../../../../shared/Container/depot.service';
import { Port } from '../../../../../../../shared/Container/model/depots/Port';
import { ContainerHubAndPark } from '../../../../../../../shared/Container/model/depots/ContainerHubAndPark';
import { TbcEnum } from '../../../../../../../shared/Container/enum/depot/TbcEnum';
import { HubTypeEnum } from '../../../../../../../shared/Container/enum/depot/HubTypeEnum';
import { CustomDateRangePickerComponent } from '../../../../../../../shared/components/custom-date-range-picker/custom-date-range-picker.component';

@Component({
  selector: 'app-container-depot-hub-data-form',
  standalone: true,
  imports: [ReactiveFormsModule, CommonModule, NgSelectModule, CustomDateRangePickerComponent],
  templateUrl: './container-depot-hub-data-form.component.html',
  styleUrl: './container-depot-hub-data-form.component.scss'
})
export class ContainerDepotHubDataFormComponent {
  private _isFullLegOnly: boolean = false;
  private _selectedDivision!: Division | null;

  private abstractContainerJobTypeHelper!: AbstractContainerJobTypeHelper;

  @Input()
  jobType!: JobTypeEnum | null;

  @Input()
  isCollectPoint: boolean = false

  @Input() set isFullLegOnly(value: boolean) {
    this._isFullLegOnly = value;
    this.onIsFullLegOnlyChanged();
  }

  get isFullLegOnly(): boolean {
    return this._isFullLegOnly;
  }

  @Input() set selectedDivision(value: Division | null) {
    this._selectedDivision = value;
    this.getContainerHubs(this._selectedDivision);
    this.getContainerParks(this._selectedDivision);
  }

  isInitialized: boolean = false;
  @Input()
  formGroup!: FormGroup;

  availableMtLocations: Port[] = [];
  availableFullHubsOrParks: ContainerHubAndPark[] = [];
  availableMTHubsOrParks: ContainerHubAndPark[] = [];

  constructor(private containerJobService: ContainerService,
    private depotManagementService: DepotManagementService) { }

  ngOnInit() {
    this.abstractContainerJobTypeHelper = new AbstractContainerJobTypeHelper();

    this.getContainerParks(this.selectedDivision);
    this.getContainerHubs(this.selectedDivision);

    this.isInitialized = true;
  }

  isInboundJob = () => this.abstractContainerJobTypeHelper && this.abstractContainerJobTypeHelper.isInboundJob(this.jobType);
  isIntermodalJob = () => this.abstractContainerJobTypeHelper && this.abstractContainerJobTypeHelper.isIntermodalJob(this.jobType);
  showPortData = () => this.jobType !== null && this.abstractContainerJobTypeHelper && !this.abstractContainerJobTypeHelper.isMoveJob(this.jobType);

  isVisible(): boolean {
    return (this.showPortData() && !this.isFullLegOnly);
  }

  doesControlExist(controlName: string): boolean {
    if(this.formGroup){
      return this.formGroup.controls[controlName] !== undefined && this.formGroup.controls[controlName] !== null;
    }else{
      return false;
    }
  }

  getFormPartial = (formPath: string) => this.formGroup.get(formPath) as FormControl;

  onIsFullLegOnlyChanged() {
    if (!this.abstractContainerJobTypeHelper) {
      this.abstractContainerJobTypeHelper = new AbstractContainerJobTypeHelper();
    }

    if (this.formGroup === undefined || this.formGroup === null) return;

    if (this.isVisible()) {
      this.formGroup.controls["mtLocation"].setValidators([Validators.required]);
    }
    else {
      this.formGroup.controls["mtLocation"].clearValidators();
      this.formGroup.controls["mtRequestedDeliveryDate"].clearValidators();
    }
    this.formGroup.controls["mtLocation"].updateValueAndValidity();
    this.formGroup.controls["mtRequestedDeliveryDate"].updateValueAndValidity();
  }

  getContainerHubs(selectedDivision: Division | null) {
    if (selectedDivision) {
      this.depotManagementService.getContainerHubsByDivision(selectedDivision.regionId)
        .subscribe(hubs => {
          this.availableFullHubsOrParks = [];
          this.availableMTHubsOrParks = [];

          this.availableFullHubsOrParks = hubs.filter(hub =>
            hub.types.some(type => type.hubTypeId === HubTypeEnum.HubFull)
          );

          this.availableMTHubsOrParks = hubs.filter(hub =>
            hub.types.some(type => type.hubTypeId === HubTypeEnum.HubMt)
          );

          if (this.formGroup) {
            this.formGroup.controls["inboundHub"].reset();
            this.formGroup.controls["outboundHub"].reset();
          }
        });
    }
  }

  getContainerParks(selectedDivision: Division | null) {
    if (selectedDivision) {
      this.containerJobService.getContainerParksByDivision(selectedDivision.regionId)
        .subscribe((ports: Port[]) => {
          this.availableMtLocations = ports;

          if (this.formGroup.get('mtLocation')?.value === null) {
            const setValue = this.formGroup.get('mtLocation')?.value;

            if (setValue) {
              const port = this.availableMtLocations.find(port => port.code === setValue.code);
              if (port) {
                this.formGroup.controls["mtLocation"].patchValue(port);
                return;
              }
            }
            this.formGroup.controls["mtLocation"].reset();
          }
        });
    }
  }
}
